export const fontSizes = {
  xs: "0.75rem",        // 12px
  sm: "0.875rem",       // 14px
  md: "1rem",           // 16px
  lg: "1.125rem",       // 18px
  xl: "1.25rem",        // 20px
  'xl-mid': "1.375rem", // 22px  - line-height 30
  "2xl": "1.5rem",      // 24px
  "3xl": "1.875rem",    // 30px
  "3xl-mid": "2rem",    // 32px - line-height 48
  "4xl": "2.25rem",     // 36px
  "4xl-mid": "2.5rem",  // 40px - line-height 56
  "5xl": "3rem",        // 48px
  "6xl": "3.75rem",     // 60px
  "7xl": "4.5rem",      // 72px
  "8xl": "6rem",        // 96px
  "9xl": "8rem",        // 128px
};
